import { useLang } from '../i18n';

const PHONE_HREF = 'tel:+18059229684';
const MAPS_HREF = 'https://www.google.com/maps/dir/?api=1&destination=926+W+Main+St,+Santa+Maria,+CA+93458';
const LOGO_URL = '/images/logo.png';

const INSTAGRAM_URL = 'https://www.instagram.com/supermufflerinc?igsh=NTc4MTIwNjQ2YQ%3D%3D';
const FACEBOOK_URL = 'https://www.facebook.com/supermufflerinc';
const TIKTOK_URL = 'https://www.tiktok.com/@supermuffler';

function FacebookIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function TikTokIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z"/>
    </svg>
  );
}

const socialIconStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  width: 36, height: 36, borderRadius: 8,
  background: 'var(--sm-border)', color: 'var(--sm-muted)',
  textDecoration: 'none', transition: 'background 0.15s ease, color 0.15s ease',
};

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="sm-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={LOGO_URL} alt="Super Muffler Inc." style={{ height: 64, width: 'auto', maxWidth: 240, display: 'block', marginBottom: '0.75rem', objectFit: 'contain' }} loading="lazy" />
            <p>{t.footerDesc}</p>
            <div style={{ display: 'flex', gap: '0.6rem', marginTop: '0.5rem' }}>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Super Muffler Inc. on Instagram"
                style={socialIconStyle}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'linear-gradient(135deg, #f58529, #dd2a7b, #8134af)'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--sm-border)'; e.currentTarget.style.color = 'var(--sm-muted)'; }}
              >
                <InstagramIcon />
              </a>
              <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Super Muffler Inc. on Facebook"
                style={socialIconStyle}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#1877f2'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--sm-border)'; e.currentTarget.style.color = 'var(--sm-muted)'; }}
              >
                <FacebookIcon />
              </a>
              <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Super Muffler Inc. on TikTok"
                style={socialIconStyle}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#000'; e.currentTarget.style.color = '#fff'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--sm-border)'; e.currentTarget.style.color = 'var(--sm-muted)'; }}
              >
                <TikTokIcon />
              </a>
            </div>
          </div>
          <div className="footer-col">
            <h4>{t.footerContact}</h4>
            <ul>
              <li><a href={PHONE_HREF}>(805) 922-9684</a></li>
              <li><a href={MAPS_HREF} target="_blank" rel="noopener noreferrer">926 W Main St</a></li>
              <li>Santa Maria, CA 93458</li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>{t.footerHours}</h4>
            <ul>
              <li>{t.footerMonThu}</li>
              <li>{t.footerFri}</li>
              <li style={{ color: 'var(--sm-red)', fontWeight: 600 }}>{t.footerWeekend}</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Super Muffler Inc. {t.footerRights}</p>
          <p><a href="#" style={{ color: 'var(--sm-muted)', textDecoration: 'none', fontSize: '13px' }}>{t.footerPrivacy}</a></p>
          <p style={{ fontSize: '11px', color: 'var(--sm-muted)', marginTop: '0.25rem' }}>3D model '1958 Pontiac Bonneville' by everhard on Sketchfab</p>
        </div>
      </div>
    </footer>
  );
}
